/* eslint-disable no-undefined */
import Constant from '@/common/constant/Constant';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import Utils from '@/common/utils/utils';
import I18n from '@/rI18n';
import API from '@aws-amplify/api';
import { Button, makeStyles } from '@material-ui/core';
import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import { SnackbarProvider } from 'notistack';
import { useRef, useState } from 'react';
import { hideLoadingMouse } from '../common/utils/CustomCursor';
import { updateUserWorkspacePanel } from '@/common/utils/ServiceFactoryUtil';

const serviceFactory = Component => props => {
    const [errorHandleStatte, setErrorHandleState] = useState({
        isOpenConfirmPopup: false,
        messageKey: '',
        variables: ''
    });
    const [disableConfirmButton, setDisableConfirmButton] = useState(false);
    const notistackRef = useRef();

    const checkUserAuthenticated = async () => {
        return true;
    }

    // TODO: namtv must refactor
    const handleReloadData = async () => {
        setDisableConfirmButton(true);
        const { messageKey, variables } = errorHandleStatte;
        if (messageKey === Constant.MSG_CM_DELETED_TICKET) {
            // TODO: need to refactor in next sprint, get ticket id from error server
            const ticketId =
                variables?.params?.id ||
                variables?.prepareDataForTicketDetailRequestDto?.ticketId ||
                variables?.updateTicketRequestDto?.ticketId ||
                '';
            await updateUserWorkspacePanel(ticketId);
        }
        window.location.reload();
    };

    const BaseAPI = {
        graphql: async params => {
            let paramsWithConfigOptions = {
                ...params,
                options: {
                    fetchPolicy: 'network-only'
                }
            };
            return new Promise((resolve, reject) => {
                API.graphql(paramsWithConfigOptions)
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        console.log('err :>>----------', err);
                        hideLoadingMouse();
                        if (Utils.isEmptyObject(err.data)) {
                            let errorResponse = err?.errors[0]?.message;
                            if (
                                errorResponse &&
                                errorResponse === 'Request failed with status code 403'
                            ) {
                                notistackRef.current.enqueueSnackbar(
                                    I18n.get(Constant.SERVER_ERROR),
                                    {
                                        variant: 'error',
                                        autoHideDuration: 3000
                                    }
                                );
                                reject(false);
                                return;
                            }
                        }
                        if (err.data === undefined || err.data === null) {
                            reject(err);
                            return;
                        }
                        let firstKey = Object.keys(err.data)[0];
                        if (err.data[firstKey] !== null) {
                            resolve(err);
                        } else {
                            const errorResponse = err.errors[0].message;
                            const errorList = errorResponse.split('==');
                            const errorType = errorList[0];
                            const errorMessage = errorList[1];
                            switch (errorMessage) {
                                case Constant.SERVER_ERROR: {
                                    const isErrorDefault =
                                        errorList.length === 1 ||
                                        !Constant.CONTROLLABLE_ERROR_TYPE.includes(errorType) ||
                                        errorMessage === Constant.SERVER_ERROR;
                                    if (isErrorDefault) {
                                        notistackRef.current.enqueueSnackbar(
                                            I18n.get(Constant.SERVER_ERROR),
                                            {
                                                variant: 'error',
                                                autoHideDuration: 3000
                                            }
                                        );
                                        reject(false);
                                    } else {
                                        err.errors[0].message = errorMessage;
                                        reject(err);
                                    }
                                    break;
                                }
                                case Constant.MSG_CM_DELETED_TICKET:
                                    setErrorHandleState({
                                        isOpenConfirmPopup: true,
                                        variables: params?.variables,
                                        messageKey: Constant.MSG_CM_DELETED_TICKET
                                    });
                                    break;
                                default:
                                    err.errors[0].message = errorMessage;
                                    reject(err);
                                    break;
                            }
                        }
                    });
            });
        },
        // REST API GET QUERY
        get: async (apiName, path, params) => {
            let isUserAuthenticated = await checkUserAuthenticated();

            if (isUserAuthenticated) {
                return new Promise((resolve, reject) => {
                    API.get(apiName, path, params)
                        .then(res => {
                            resolve(res);
                        })
                        .catch(err => {
                            reject(err);
                        });
                });
            } else {
                console.log('User UnAuthenticated');
                return new Promise((resolve, reject) => {
                    reject();
                });
            }
        },
        // REST API POST QUERY
        post: async (apiName, path, params) => {
            let isUserAuthenticated = await checkUserAuthenticated();

            if (isUserAuthenticated) {
                return new Promise((resolve, reject) => {
                    API.post(apiName, path, params)
                        .then(res => {
                            resolve(res);
                        })
                        .catch(err => {
                            reject(err);
                        });
                });
            } else {
                console.log('User UnAuthenticated');
                return new Promise((resolve, reject) => {
                    reject();
                });
            }
        }
    };

    const onClickDismiss = key => () => {
        notistackRef.current.closeSnackbar(key);
    };

    const useStyles = makeStyles(theme => ({
        success: { top: '40px' }
    }));

    const classes = useStyles();

    return (
        <SnackbarProvider
            maxSnack={1}
            preventDuplicate
            ref={notistackRef}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
            action={key => (
                <Button className="notistack-button" onClick={onClickDismiss(key)}>
                    <CloseIcon />
                </Button>
            )}
            TransitionComponent={Slide}
            classes={{
                root: classes.success
            }}
        >
            <ConfirmDialog
                isOpen={errorHandleStatte.isOpenConfirmPopup}
                msgConfirm={I18n.get(`${errorHandleStatte.messageKey}`)}
                okCallBack={handleReloadData}
                disableButtonCallBack={disableConfirmButton}
            />

            <Component {...props} API={BaseAPI} />
        </SnackbarProvider>
    );
};

export default serviceFactory;
